/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React,{useEffect, useState} from "react";
// react plugin used to create charts
// reactstrap components
import { Line, Pie } from "react-chartjs-2";
import gif from '../images/loading.gif'
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import YearPicker from 'react-single-year-picker'

// core components
import {
  dashboard24HoursPerformanceChart,
  dashboardEmailStatisticsChart,
  dashboardNASDAQChart,
} from "variables/charts.js";
import {
  dashboardNASDAQChart1,
} from "variables/year";
import {connect, useSelector} from "react-redux";
import firebase from '../config/firebase'


function Dashboard(props) {
  const d = new Date();
  const [Graph, setGraph] = React.useState(false);
  const [yearSelected, setYearME] = useState(d.getFullYear());
  const [yearSelectedEnd, setYearMEEnd] = useState(d.getFullYear()+8);



  // Chart Data

  let [data,setData]=useState([])
  let [year,setYear]=useState(d.getFullYear())
  let [Currentyear,setCurrentYear]=useState(d.getFullYear())
  const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];

  useEffect(()=>{
  showChart(year)
  showChart1(yearSelected,yearSelectedEnd)

  },[])

  let showChart=(CurrentYear)=>{
    month.map((v,i)=>{
      firebase.firestore().collection('booking').
    where('hotel_admin_uid', '==', localStorage.getItem('admin_uid')).where('month','==',v)
    .onSnapshot((querySnapshot) => {
      var all = [];
      querySnapshot.forEach((doc) => {
        if(doc.data().year==CurrentYear){
  
          all.push(doc.data());
        }
      });
  sessionStorage.setItem(v,all.length)
      })
  
     let jan= sessionStorage.getItem('January')==null ? '0' :sessionStorage.getItem('January')
     let feb= sessionStorage.getItem('February')==null ? '0' :sessionStorage.getItem('February')
     let mar= sessionStorage.getItem('March')==null ? '0' :sessionStorage.getItem('March')
     let april= sessionStorage.getItem('April')==null ? '0' :sessionStorage.getItem('April')
     let may= sessionStorage.getItem('May')==null ? '0' :sessionStorage.getItem('May')
     let june= sessionStorage.getItem('June')==null ? '0' :sessionStorage.getItem('June')
     let july= sessionStorage.getItem('July')==null ? '0' :sessionStorage.getItem('July')
     let august= sessionStorage.getItem('August')==null ? '0' :sessionStorage.getItem('August')
     let sep= sessionStorage.getItem('September')==null ? '0' :sessionStorage.getItem('September')
     let oct= sessionStorage.getItem('October')==null ? '0' :sessionStorage.getItem('October')
     let nov= sessionStorage.getItem('November')==null ? '0' :sessionStorage.getItem('November')
     let dec= sessionStorage.getItem('December')==null ? '0' :sessionStorage.getItem('December')
    
  let data=[jan,feb,mar,april,may,june,july,august,sep,oct,nov,dec]
 


setTimeout(() => {
  setData(data)
}, 1000);
setTimeout(() => {
  setGraph(true)
}, 3000);

  }) 
  }











  let showChart1=(yearSelected,yearSelectedEnd)=>{
    let StartME=yearSelected
    let EndME=yearSelectedEnd
    sessionStorage.setItem('EndME',EndME)
    sessionStorage.setItem('StartME',StartME)

let Start=yearSelected
    let year=[]
for (let i = 0; i < yearSelectedEnd-yearSelected +1; i++) {
  year.push(Start +i)
}
let arr=[]
year.map((v,i)=>{
  firebase.firestore().collection('booking').
  where('hotel_admin_uid', '==', localStorage.getItem('admin_uid'))
  .onSnapshot((querySnapshot) => {
    querySnapshot.forEach((doc) => {
      if(year[i]== doc.data().year ){

          arr.push(doc.data())
        }
      });
      sessionStorage.setItem(v,arr.length)
      arr=[]
      })
  
  })
  }
  useEffect(() => {
   
        // Anything in here is fired on component unmount.
        
   document.body.style.background = null;
  document.body.style.padding = "";
  document.body.style.display = "";
  document.body.style.justifyContent = "";
  document.body.style.alignItems = "";
  document.body.style.minHeight = "";
  document.body.style.fontFamily = "'Jost', sans-serif";
  document.body.style.alignItems = "";
  
 
}, [])
  return (
    <>
   
      <div className="content">
        <Row>
         
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-money-coins text-success" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Revenue</p>
                      <CardTitle tag="p">$ 1,345</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="far fa-calendar" /> Last day
                </div>
              </CardFooter>
            </Card>
          </Col>
          
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center icon-warning">
                      <i className="nc-icon nc-favourite-28 text-primary" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Followers</p>
                      <CardTitle tag="p">+45K</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  <i className="fas fa-sync-alt" /> Update now
                </div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
        <Row>
        {
          Graph?
          <Col md="8">
          <Card className="card-chart">
            <CardHeader style={{display:'flex',flexDirection:'row',width:'98%',alignItems:'center',justifyContent:'space-between',alignItems:'center'}}>
              <CardTitle tag="h5">Monthly Revenue Graph</CardTitle>
            <div class="btn-group">
<button type="button" class="btn btn-danger">{year}</button>
<button type="button" class="btn btn-danger dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
  <span class="sr-only">Toggle Dropdown</span>
</button>
<div class="dropdown-menu">
  <a class="dropdown-item" onClick={()=>{setYear(Currentyear-3);    showChart(Currentyear-3)}}  href="#">{Currentyear-3}</a>
  <a class="dropdown-item" onClick={()=>{setYear(Currentyear-2);    showChart(Currentyear-2)}}  href="#">{Currentyear-2}</a>
  <a class="dropdown-item" onClick={()=>{setYear(Currentyear-1);    showChart(Currentyear-1)}}  href="#">{Currentyear-1}</a>
  <a class="dropdown-item" onClick={()=>{setYear(Currentyear);    showChart(Currentyear)}}  href="#">{Currentyear}</a>

</div>
</div>
            </CardHeader>
            <CardBody>
             {data.length>0?
              <Line
              data={dashboardNASDAQChart.data(data)}
              options={dashboardNASDAQChart.options}
              width={400}
              height={100}
            />:
            null}
            </CardBody>
            <CardFooter>
              <div className="chart-legend">
                <i className="fa fa-circle text-warning" /> {" Booking  "}
              </div>
              <hr />
              <div className="card-stats">
                <i className="fa fa-check" />
              </div>
            </CardFooter>
          </Card>
        </Col>
        :
<>
<img style={{width:'65%',height:400,objectFit:'cover'}} src={'https://thumbs.gfycat.com/GeneralUnpleasantApisdorsatalaboriosa-size_restricted.gif'}></img>
 

</>
        }







<Col md="8">
          <Card className="card-chart">
            <CardHeader style={{display:'flex',flexDirection:'row',width:'98%',alignItems:'center',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap'}}>
              <CardTitle tag="h5">Monthly Revenue Graph</CardTitle>
        <div style={{width:400,display:'flex',alignItems:'center',justifyContent:'flex-start',flexWrap:'wrap'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',fontWeight:'bold',color:'grey',width:200}}>
          Select Start Year :
     <div> {yearSelected}
        <YearPicker
        yearArray={['2019', '2020']}
        value={yearSelected}
        onSelect={(e) => {setYearME(e); showChart1(e,yearSelectedEnd)}}
        hideInput={true}
        activeIcon={'https://www.freeiconspng.com/thumbs/calendar-image-png/calendar-image-png-3.png'}
        icon={'https://www.freeiconspng.com/thumbs/calendar-image-png/calendar-image-png-3.png'}
        leftIcon={'https://www.freeiconspng.com/thumbs/calendar-image-png/calendar-image-png-3.png'}
        rightIcon={'https://www.freeiconspng.com/thumbs/calendar-image-png/calendar-image-png-3.png'}
        minRange={2000}
        maxRange={Currentyear}
      /></div>
        </div>
        



        <div style={{display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',fontWeight:'bold',color:'grey',width:200}}>
          Select End Year :
     <div> {yearSelectedEnd}
        <YearPicker
        yearArray={['2019', '2020']}
        value={yearSelectedEnd}
        onSelect={(e) => {setYearMEEnd(e); showChart1(yearSelected,e)}}
        hideInput={true}
        activeIcon={'https://www.freeiconspng.com/thumbs/calendar-image-png/calendar-image-png-3.png'}
        icon={'https://www.freeiconspng.com/thumbs/calendar-image-png/calendar-image-png-3.png'}
        leftIcon={'https://www.freeiconspng.com/thumbs/calendar-image-png/calendar-image-png-3.png'}
        rightIcon={'https://www.freeiconspng.com/thumbs/calendar-image-png/calendar-image-png-3.png'}
        minRange={2000}
        maxRange={Currentyear + 10}
      /></div>
        </div>
         </div>
            </CardHeader>
            <CardBody>
             {data.length>0?
              <Line
              data={dashboardNASDAQChart1.data(data)}
              options={dashboardNASDAQChart.options}
              width={400}
              height={100}
            />:
            null}
            </CardBody>
            <CardFooter>
              <div className="chart-legend">
                <i className="fa fa-circle text-warning" /> {" Booking  "}
              </div>
              <hr />
              <div className="card-stats">
                <i className="fa fa-check" />
              </div>
            </CardFooter>
          </Card>
        </Col>
        </Row>
      </div>
    </>
  );
}



const mapStateToProps = (state) => {
  return {
    hotel_data:state.hotel_data,
  }
}


const mapDispatchToProps = dispatch => {
  return {
    // dispatching plain actions
    // get_data: () => dispatch(get_data())  
  
  }}
  export default connect(mapStateToProps,mapDispatchToProps)(Dashboard)
